import { Locale } from '@klokhuis/core/Intl/types';

import { AnalyticsUserProperties } from '../types';

export function getPageEventPayload(
  locale: string,
  pageProperties?: Record<string, unknown>,
  userProperties?: AnalyticsUserProperties,
): any {
  return {
    klokhuisApp: 'next',
    language: locale === Locale.en ? 'English' : 'Tamil',
    ...pageProperties,
    ...userProperties,
  };
}
